import * as yup from "yup";

export const schemeValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  year: yup.number().required("Year is required"),
  assessmentPeriod: yup.string().required("Assessment period is required"),
  salaryPaid: yup.number().required("Salary paid is required"),
});
